
document.querySelectorAll( '.fileinp' ).forEach( inpwrap => {
    const inp = inpwrap.querySelector( 'input' );
    inp.addEventListener( 'input', ( e ) => {
        const placeholder = inpwrap.querySelector( '.fileinp__placeholder' );
        const filename = inp.files?.[0]?.name;
        if ( !placeholder ) return;
        placeholder.innerHTML = filename ?? "Image Upload";
        inpwrap.dataset.chosen = !!filename;
    } );
} );